<template>
  <div class="fondo_transparente">
    <div class="ventana_modal" id="dragg-cont" ref="draggCont">
      <XCerrarModal @click="cerrarModal" id="XCerrar"/>
      <div class="headerModal" id="dragg-header" @mousedown="dragMouseDown">
        <p>Idiomas</p>
      </div>
      <div class="body">
        <div id="L1">
          <p id="idiomaDeco">{{idiomaSeleccionado.idioma}}</p>
          <p id="enviar" @click="enviarIdioma(idiomaSeleccionado)">&rtrif;</p>
        </div>
        <input class= "idiomas" type="search" v-model="busqueda" placeholder=" Buscar idioma" autofocus />
        <div class= "lista">
          <ul
            @click="seleccionarIdioma(idioma)"
            v-for="idioma in filtroIdiomas" :key="idioma._id" :value="idioma">
            {{idioma.idioma}}
          </ul>
        </div>
        <!-- :class="{seleccionado: seleccionado === idioma._id}" -->
        <br>
        <div id="L3">
          <button @click="nuevoIdioma" class="button-med">
          <span class="icon-icoMasSolo ico"></span>Nuevo</button>
          <button @click="editIdioma" class="button-med">
          <span class="icon-icoEditSolo ico"></span>Editar</button>
          <button @click="verifIdioma" class="button-med">
          <span class="icon-icoSubirNube ico"></span>Guardar</button>
        </div>
        <br>
        <div v-show="visible" class="inputIdioma">
          <input
            type="text"
            placeholder=" Escribe el idioma"
            id="idioma"
            class= "idiomas"
            v-model="idiomaGestionado.idioma">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  props: {
    idiomas: Array
  },
  components: { XCerrarModal },
  name: 'ModalIdiomas',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.busqueda = ''
  },
  data () {
    return {
      idiomaSeleccionado: {},
      idiomaGestionado: {},
      busqueda: '',
      visible: false,
      seleccionado: '',
      URLbase: '',
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      }
    }
  },
  methods: {
    seleccionarIdioma (idioma) {
      this.idiomaSeleccionado = idioma
    },
    cerrarModal: function () {
      this.visible = false
      this.$emit('cerrar')
    },
    enviarIdioma (seleccionado) {
      if (seleccionado.idioma) {
      // console.log('Seleccionado es: ' + !!seleccionado.idioma)
        this.$emit('AddIdioma', seleccionado)
        this.idiomaSeleccionado = {}
        this.busqueda = ''
      } else {
        console.log('Seleccionado es: ' + !!seleccionado.idioma)
      }
    },
    nuevoIdioma () {
      this.visible = true
      this.idiomaGestionado = {}
      // this.idiomaGestionado.Id = '0'
    },
    editIdioma () {
      this.visible = true
      this.idiomaGestionado = this.idiomaSeleccionado
    },
    verifIdioma () {
      const a = this.idiomas.filter(e => e.idioma.toLowerCase() === this.idiomaGestionado.idioma.toLowerCase()).length
      console.log(a)
      // console.log('Idioma repetido: ' + a)
      if (a) {
        this.idiomaGestionado = {}
        console.log('Idioma repetido')
        this.alertJoa('El idioma ya está registrado', 'W')
      } else {
        console.log('Se puede guardar el idioma')
        this.saveIdioma()
      }
    },
    async saveIdioma () {
      try {
        const url = `${this.URLbase}/idiomas/save`
        const idioma = this.idiomaGestionado
        axios.post(url, idioma)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error en proceso, reinicia la aplicación e intenta otra vez', 'E')
                break
              case 'success':
                console.log('Idioma cargado con éxito!')
                this.visible = true
                this.idiomaSeleccionado = this.idiomaGestionado
                break
            }
          })
          .catch(error => console.log(error))
        this.$emit('recargar')
      } catch (error) {
        alert(error)
      }
    },
    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      // set the element's new position:
      this.$refs.draggCont.style.top = (this.$refs.draggCont.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggCont.style.left = (this.$refs.draggCont.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },
  computed: {
    filtroIdiomas () {
      return this.idiomas.filter(idioma => {
        return idioma.idioma.toLowerCase().includes(this.busqueda.toLowerCase())
      })
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.lista ul:hover{
  /* background-color: rgba(0, 58, 68, 0.9); */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight:bold;
}
.ventana_modal{
    /* background: -webkit-linear-gradient(115deg, rgb(180, 180, 180),rgb(214, 214, 214),rgb(180, 180, 180), rgb(68, 68, 68)); */
    background-color: rgb(211, 210, 210);
    width: 400px;
    /* min-height: 200px; */
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    display: grid;
    grid-template-rows: 20% 80%;
    font-family: OpenL;
    /* border:  1px solid rgb(179, 179, 179) */
    z-index: 100;
    box-shadow: rgb(43, 43, 43) 4px 4px 20px;
}
.headerModal{
  background-color: var(--azul2);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  display: flex;
}
#dragg-cont {
  position: absolute;
  z-index: 9;
}
#dragg-header {
  cursor: move;
  z-index: 10;
}
#XCerrar{
  z-index: 11;
}
.headerModal p{
  text-align: left;
  margin-left: 20px;
  align-self: center;
  color: var(--na);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 30px;
  font-weight: lighter;
}
.body{
  margin: 18px;
  display:flex;
  flex-direction: column;
  color:rgb(20, 76, 109)
}
#L1{
  height: 25px;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 5px;
  /* border: 0.5px solid orange; */
}
#L1 #idiomaDeco{
  text-align: left;
  /* padding-bottom: 5px; */
  font-style: oblique;
  /* font-weight:900; */
  color:rgb(20, 76, 109);
  /* border:  1px solid orange; */
}
#L1 #enviar{
  background-color: var(--azul2);
  color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  font-size: 24px;
  padding: 0px 10px 0px 10px;
  border-radius: 3px;
  cursor: pointer;
  min-height: 25px;
  margin-bottom: 2px;
  vertical-align: middle;
  line-height: 20px;
  transition: all 0.5s ease-out;
}
#L1 #enviar:hover{
  transform: translateX(5px);
  /* background-color: rgba(0, 58, 68) */
}
.lista{
  width: 100%;
  min-height: 27px;
  height:98px;
  overflow: auto;
  font-size: 14px;
  border-radius: 3px;
  background-color: var(--gris3);
  border:  1px solid rgb(185, 185, 185);
  cursor:pointer;
}
/* .seleccionado{ */
  /* color:rgb(241, 217, 0); */
/* } */
/* .seleccionado:hover{ */
  /* font-weight:bold; */
/* } */
.idiomas{
  height: 35px;
  border:  1px solid rgb(185, 185, 185);
  border-radius: 3px;
  font-family: OpenL;
  margin-bottom: 3px;
}
.idiomas:focus{
  outline: none;
}
.inputIdioma{
  display: grid;
}
#idioma{
  margin-bottom: 5px;
  outline:none;
  height: 18px;
}
#mas{
  background-color:rgba(0, 58, 68, 0.9);
  color:white;
  font-size: 14px;
  font-weight: 600;
}
#L3{
  /* background-color: rgba(0, 58, 68, 0.9); */
  display: flex;
  justify-content: space-around;

  /* padding: 2px; */
}
.button-med{
  width:100px;
  height:30px;
}
.icon-icoMasSolo{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 2px;
  padding-right: 7px;
  /* border:  1px solid rgb(179, 179, 179) */
}
.icon-icoEditSolo{
  color: var(--az-ico);
  font-size: 1.35em;
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 2px;
  /* border:  1px solid rgb(179, 179, 179) */
}
.icon-icoSubirNube{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 0px;
  padding-right: 10px;
  /* border:  1px solid rgb(179, 179, 179) */
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 90%;
  }
  .container{
    display: flex;
    flex-direction: column;
    font-size: 1rem
  }
}
</style>
